import _ from 'lodash'

const isPopularAuthorsLoading = (state) => _.get(state, 'loading')
const popularAuthors = (state) => _.get(state, 'popularAuthors')
const total = (state) => _.get(state, 'total')
const author = (state) => _.get(state, 'author')
const errors = (state) => _.get(state, 'errors')
const followers = (state) => _.get(state, 'followers')
const followings = (state) => _.get(state, 'followings')
const speaker = (state) => _.get(state, 'speaker')
const speakerIdLoading = (state) => _.get(state, 'speakerSessionIdLoading')

const isLoading = (state) => _.get(state, 'loading')
const isSpeakerSessionLoading = (state) => _.get(state, 'isSpeakerSessionLoading')

const followersCount = (state) => _.get(state, 'followersCount')
const followingsCount = (state) => _.get(state, 'followingsCount')
const followersLoading = (state) => _.get(state, 'followersLoading')
const followingsLoading = (state) => _.get(state, 'followingsLoading')
const showSuccess = (state) => _.get(state, 'showSuccess')
const showError = (state) => _.get(state, 'showError')

export default {
	isPopularAuthorsLoading,
	popularAuthors,
	author,
	total,
	followings,
	followers,
	followersCount,
	followingsCount,
	followersLoading,
	followingsLoading,
	errors,
	showSuccess,
	showError,
	speaker,
	isLoading,
	speakerIdLoading,
	isSpeakerSessionLoading
}
